import {ErrorHandler, Inject, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';

import { AppComponent } from './app.component';
import { CoreModule } from '@Common/core/core.module';

import { CommonModuleP8 } from '@Common/common-p8.module';
import { AppRoutingModule } from './app-routing';

import { HandlerError } from '@Common/handler-error';
import { FlexLayoutModule } from '@Common/widgets/flex-layout/flex-layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {CommonModule, registerLocaleData} from '@angular/common';
import { MatAngularModule } from '@Common/mat-angular.module';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {AccueilComponent} from "./accueil/accueil.component";

import {OverlayContainer} from "@angular/cdk/overlay";

import {CustomPaginatorService} from "./common/custom-paginator/custom-paginator.service";
import {PieceJointeUploaderModule} from "@Common/widgets/piece-jointe-uploader/piece-jointe-uploader.module";

import {CommonDarModule} from "./common/common.module";

import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

// import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
// import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core'

import localeFr from "@angular/common/locales/fr";
import localeFrExtra from "@angular/common/locales/extra/fr";
import {DossierModule} from "app/dar/dossier/dossier.module";
import {CustomDateAdapter} from "@Common/core/providers/custom-date-adapter";
import {AideComponent} from './aide/aide.component';
import { ReminderDarNavComponent } from './accueil/reminder-dar-nav/reminder-dar-nav.component';
import { ReminderListComponent } from './accueil/reminder-dar-nav/reminder-list/reminder-list.component';


registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

export const FR_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
    imports: [
        BrowserAnimationsModule,
        CoreModule,
        CommonModuleP8,
        AppRoutingModule,
        FlexLayoutModule,
        MatAngularModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PieceJointeUploaderModule,
        CommonDarModule,
        DossierModule,
    ],
    declarations: [
        AppComponent,
        AccueilComponent,
        AideComponent,
        ReminderDarNavComponent,
        ReminderListComponent,
    ],
    exports: [],
    providers: [
        { provide: MatPaginatorIntl, useClass: CustomPaginatorService },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        /* voir https://stackoverflow.com/a/51770825/55465 quand on sera en Angular 7 / Material 7 (adapter moment) */
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: FR_FORMATS },
        // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        // {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
        { provide: ErrorHandler, useClass: HandlerError },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(@Inject(OverlayContainer) private overlayContainer: OverlayContainer) {
    // this.overlayContainer
    //   .getContainerElement()
    //   .classList.add("custom-dar-colors");
  }
}
